<div class="row p-1">
  <div class="col-12 pageTitle">
    <h2>&nbsp;&nbsp;&nbsp;Param List</h2>
  </div>
</div>

<div class="card">
  <div class="p-fluid formgrid grid">
    <div class="field col-12 md:col-10 mb-0 pt-1">
      <h4 class="mb-0">{{ reportName }}</h4>
    </div>

    <div class="field col-2 md:col-2 mb-0 alignRight">
      <button
        pButton
        type="button"
        pTooltip=""
        label="Add Params"
        pTooltipPosition="true"
        icon="pi pi-book"
        class="ui-button-plain buttonWidth-10"
        (click)="onAddParamReports()"
      ></button>
    </div>
  </div>
</div>

<!--<p-table *ngIf="reportparam" [columns]="cols" [value]="reportparam.data" selectionMode="single" dataKey="reportparamid" [resetPageOnSort]="false" [lazy]="false"
         [(selection)]="selectedparamreport" [paginator]="true" [rows]="10">-->

<p-table
  *ngIf="reportParam"
  [resetPageOnSort]="false"
  lazy="true"
  (onLazyLoad)="nextPage($event)"
  [totalRecords]="reportParam?.totalRecords"
  [currentPageReportTemplate]="'{currentPage} of {totalPages}'"
  [columns]="cols"
  [alwaysShowPaginator]="false"
  [rows]="rows"
  [paginator]="true"
  [value]="reportParam?.data"
  selectionMode="single"
  [sortOrder]="1"
  sortField="reportparamid"
  dataKey="reportparamid"
  [(selection)]="selectedReportParam"
  [autoLayout]="true"
>
  <ng-template pTemplate="header" let-columns>
    <tr *ngIf="showRecords == true">
      <th></th>
      <th *ngFor="let col of columns" [pSortableColumn]="col.field">
        {{ col.header }}
        <p-sortIcon [field]="col.field"></p-sortIcon>
      </th>
      <th class="col-3 md:col-1">Actions</th>
    </tr>
  </ng-template>
  <ng-template
    pTemplate="body"
    let-rowData
    let-columns="columns"
    let-i="rowIndex"
  >
    <tr [pSelectableRow]="rowData">
      <td>
        <button
          pButton
          type="button"
          icon="pi pi-angle-up"
          pTooltip="Move-Up"
          class="p-button-link f2"
          (click)="moveUp(rowData, i)"
        ></button
        >&nbsp;&nbsp;
        <button
          pButton
          type="button"
          icon="pi pi-angle-down"
          pTooltip="Move-Down"
          class="p-button-link f2"
          (click)="moveDown(rowData, i)"
        ></button>
      </td>

      <td *ngFor="let col of columns">
        <div
          *ngIf="
            rowData['isrequired'] && col.field == 'datatype';
            then nested_object_content;
            else normal_content
          "
        ></div>
        <ng-template #nested_object_content> Auto </ng-template>
        <ng-template #normal_content>
          {{ rowData[col.field] }}
        </ng-template>
      </td>
      <td>
        <button
          pButton
          type="button"
          icon="pi pi-pencil"
          pTooltip="Edit"
          class="p-button-link"
          (click)="onEditParamReport(rowData['reportparamid'])"
        ></button>
        <button
          pButton
          type="button"
          icon="pi pi-trash"
          pTooltip="Delete"
          class="p-button-link ml-5"
          (click)="onDeleteParamReport($event, rowData['reportparamid'])"
        ></button>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <div class="w-12 bg-white">
      <div class="" style="text-align: center">
        <img
          _ngcontent-ng-c683320295=""
          class="profile-image"
          style="border-radius: 50%; width: 10rem; padding-top: 1rem"
          src="assets/imagesNew/table_error.png"
        />
      </div>
      <hr style="margin-bottom: 0.5rem" />
      <div
        class=""
        style="text-align: center; font-size: larger; color: #1d428f"
      >
        <i>No records found</i>
      </div>
    </div>
  </ng-template>
</p-table>
